$(document).ready(function () {
    const addLink = function () {
        const title = document.querySelector('.cookiesSetting__title')
        if (title) {
            title.insertAdjacentHTML(
                'afterend',
                `<a href="https://www.happyzoo.cz/vse-o-nakupu/ochrana-osobnich-udaju/#cookies" class="cookiesSetting__link">Jak pracujeme s cookies?</a>`
            )

            const inCookiePage = document.querySelector('.id-2641')
            const link = document.querySelector('.cookiesSetting__link')
            if (inCookiePage && link) {
                link.addEventListener('click', function () {
                    const btn = document.querySelector('#cboxClose')
                    btn.click()
                })
            }
        }
    }

    const addLinkIfSettingsBtnExists = function () {
        const settingsBtn = document.querySelector('.siteCookies__link.js-cookies-settings')
        if (settingsBtn) {
            settingsBtn.addEventListener('click', function () {
                setTimeout(addLink, 100)
            })
        }
    }

    const addLinkIfSettingsBtnBottomExists = function () {
        const settingsBtnBottom = document.querySelector('#footer .js-cookies-settings')
        const inCookiePage = document.querySelector('.id-2641')
        if (settingsBtnBottom) {
            settingsBtnBottom.addEventListener('click', function () {
                setTimeout(addLink, 100)
            })
        }
    }

    addLinkIfSettingsBtnExists()
    setTimeout(addLinkIfSettingsBtnBottomExists, 1000)
})
